import { render, staticRenderFns } from "./CampanhasMkt.vue?vue&type=template&id=acc50046"
import script from "./CampanhasMkt.vue?vue&type=script&lang=js"
export * from "./CampanhasMkt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports